export const mockPublicationsOverTimeWithDistribution = {
  series: [
    {
      id: 'publication',
      name: 'Publicações',
      data: [
        { 'y': 3152, 'date': '2023-04-11' },
        { 'y': 3999, 'date': '2023-04-12' },
        { 'y': 4312, 'date': '2023-04-13' },
        { 'y': 4445, 'date': '2023-04-14' },
        { 'y': 4534, 'date': '2023-04-15' },
        { 'y': 4623, 'date': '2023-04-17' },
        { 'y': 4638, 'date': '2023-04-18' },
        { 'y': 4656, 'date': '2023-04-19' },
        { 'y': 1494, 'date': '2023-04-20' },
        { 'y': 1502, 'date': '2023-04-21' },
        { 'y': 1511, 'date': '2023-04-22' },
        { 'y': 1522, 'date': '2023-04-23' },
        { 'y': 1546, 'date': '2023-04-24' },
        { 'y': 1560, 'date': '2023-04-25' },
        { 'y': 1576, 'date': '2023-04-26' },
        { 'y': 1595, 'date': '2023-04-27' },
        { 'y': 1632, 'date': '2023-04-28' },
        { 'y': 1649, 'date': '2023-04-29' },
        { 'y': 1651, 'date': '2023-04-30' },
        { 'y': 1680, 'date': '2023-05-03' },
        { 'y': 1700, 'date': '2023-05-04' },
        { 'y': 1737, 'date': '2023-05-05' },
      ],
    },
    {
      id: 'Interaction',
      name: 'Interações',
      data: {
        'Curtidas/gostei': [
          { 'y': 123, 'date': '2023-04-11' },
          { 'y': 343, 'date': '2023-04-12' },
          { 'y': 12, 'date': '2023-04-13' },
          { 'y': 123, 'date': '2023-04-14' },
          { 'y': 434, 'date': '2023-04-15' },
          { 'y': 435, 'date': '2023-04-17' },
          { 'y': 4638, 'date': '2023-04-18' },
          { 'y': 4656, 'date': '2023-04-19' },
          { 'y': 1494, 'date': '2023-04-20' },
          { 'y': 1502, 'date': '2023-04-21' },
          { 'y': 1511, 'date': '2023-04-22' },
          { 'y': 1522, 'date': '2023-04-23' },
          { 'y': 1546, 'date': '2023-04-24' },
          { 'y': 1560, 'date': '2023-04-25' },
          { 'y': 1576, 'date': '2023-04-26' },
          { 'y': 1595, 'date': '2023-04-27' },
          { 'y': 1632, 'date': '2023-04-28' },
          { 'y': 1649, 'date': '2023-04-29' },
          { 'y': 1651, 'date': '2023-04-30' },
          { 'y': 1680, 'date': '2023-05-03' },
          { 'y': 1700, 'date': '2023-05-04' },
          { 'y': 1737, 'date': '2023-05-05' },
        ],
        'Comentários': [
          { 'y': 323, 'date': '2023-04-11' },
          { 'y': 442, 'date': '2023-04-12' },
          { 'y': 1972, 'date': '2023-04-13' },
          { 'y': 678, 'date': '2023-04-14' },
          { 'y': 332, 'date': '2023-04-15' },
          { 'y': 123, 'date': '2023-04-17' },
          { 'y': 4638, 'date': '2023-04-18' },
          { 'y': 4656, 'date': '2023-04-19' },
          { 'y': 1494, 'date': '2023-04-20' },
          { 'y': 1502, 'date': '2023-04-21' },
          { 'y': 1511, 'date': '2023-04-22' },
          { 'y': 1522, 'date': '2023-04-23' },
          { 'y': 1546, 'date': '2023-04-24' },
          { 'y': 1560, 'date': '2023-04-25' },
          { 'y': 1576, 'date': '2023-04-26' },
          { 'y': 1595, 'date': '2023-04-27' },
          { 'y': 1632, 'date': '2023-04-28' },
          { 'y': 1649, 'date': '2023-04-29' },
          { 'y': 1651, 'date': '2023-04-30' },
          { 'y': 1680, 'date': '2023-05-03' },
          { 'y': 1700, 'date': '2023-05-04' },
          { 'y': 1737, 'date': '2023-05-05' },
        ],
        'Compartilhamento': [
          { 'y': 421, 'date': '2023-04-11' },
          { 'y': 43, 'date': '2023-04-12' },
          { 'y': 52, 'date': '2023-04-13' },
          { 'y': 234, 'date': '2023-04-14' },
          { 'y': 932, 'date': '2023-04-15' },
          { 'y': 134, 'date': '2023-04-17' },
          { 'y': 4638, 'date': '2023-04-18' },
          { 'y': 4656, 'date': '2023-04-19' },
          { 'y': 1494, 'date': '2023-04-20' },
          { 'y': 1502, 'date': '2023-04-21' },
          { 'y': 1511, 'date': '2023-04-22' },
          { 'y': 1522, 'date': '2023-04-23' },
          { 'y': 1546, 'date': '2023-04-24' },
          { 'y': 1560, 'date': '2023-04-25' },
          { 'y': 1576, 'date': '2023-04-26' },
          { 'y': 1595, 'date': '2023-04-27' },
          { 'y': 1632, 'date': '2023-04-28' },
          { 'y': 1649, 'date': '2023-04-29' },
          { 'y': 1651, 'date': '2023-04-30' },
          { 'y': 1680, 'date': '2023-05-03' },
          { 'y': 1700, 'date': '2023-05-04' },
          { 'y': 1737, 'date': '2023-05-05' },
        ],
      },
    },
  ],
  categories: 'Bradesco',
  metadata: [],
};

